export const STYLE = (disabled: boolean) => ({
  '&[disabled]': {
    opacity: 0.25,
    '&:hover': {
      opacity: 0.25,
    },
    '&:active': {
      opacity: 0.25,
    },
  },
  ...(disabled && {
    opacity: 0.25,
    '&:hover': {
      opacity: 0.25,
    },
    '&:active': {
      opacity: 0.25,
    },
  }),
});
